// @flow

import { createContext, useContext } from 'react';

export type PaymentState =
  | 'LOADING'
  | 'COLLECT_PHONE'
  | 'SUBMITTING'
  | 'WAITING_APPROVAL'
  | 'AWAITING_PAYMENT_STATUS'
  | 'TIMEOUT'
  | 'SUCCESS'
  | 'ERROR';

export type RetryState = 'LOADING' | 'COLLECT_PHONE';

export type PaymentData = {|
  +state: PaymentState,
  +paymentHash: string,
  +redirectUrlAfterPayment: ?string,
  +errorMessage: string,
  +retryState: RetryState,
  +waitingDeadline: ?number,
|};

export type PaymentAction =
  | {| +type: 'PAYMENT_QUERY_SUCCESS', +redirectUrlAfterPayment: ?string |}
  | {| +type: 'START_SUBMITTING' |}
  | {| +type: 'START_WAITING_APPROVAL', +waitingDeadline: number |}
  | {| +type: 'START_AWAITING_PAYMENT_STATUS', +waitingDeadline: number |}
  | {| +type: 'SET_WAITING_DEADLINE', +waitingDeadline: number |}
  | {| +type: 'PAYMENT_CONFIRMED' |}
  | {| +type: 'SET_TIMEOUT' |}
  | {| +type: 'RESTART_COLLECT_PHONE' |}
  | {| +type: 'SET_ERROR', +errorMessage: string, +retryState: RetryState |}
  | {| +type: 'RETRY' |};

type ContextValue = {|
  +data: PaymentData,
  +dispatch: (action: PaymentAction) => void,
|};

const PaymentContext = createContext<?ContextValue>(null);

export const PaymentProvider = PaymentContext.Provider;

export function usePayment(): ContextValue {
  const context = useContext(PaymentContext);
  if (!context) {
    throw new Error('usePayment must be used within PaymentProvider');
  }
  return context;
}
